var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.23,17.58h23.78l10.11,10.11c.54.54,1.27.84,2.04.84s1.5-.3,2.04-.84l10.96-10.96c1.13-1.13,1.13-2.95,0-4.07l-10.96-10.96c-1.08-1.08-2.99-1.08-4.07,0l-10.11,10.11h-23.78c-4.14,0-7.5,3.36-7.5,7.5v29.46h-18.85c-1.3-5.29-6.07-9.24-11.76-9.24-6.68,0-12.12,5.44-12.12,12.12s5.44,12.12,12.12,12.12c5.69,0,10.46-3.94,11.76-9.24h18.85v29.46c0,4.14,3.36,7.5,7.5,7.5h25.3v4.73c0,1.59,1.29,2.88,2.88,2.88h15.49c1.59,0,2.88-1.29,2.88-2.88v-15.49c0-1.59-1.29-2.88-2.88-2.88h-15.49c-1.59,0-2.88,1.29-2.88,2.88v5h-25.3c-.96,0-1.74-.78-1.74-1.74v-29.46h25.78c1.3,5.29,6.07,9.24,11.76,9.24,6.68,0,12.12-5.44,12.12-12.12s-5.44-12.12-12.12-12.12c-5.69,0-10.46,3.94-11.76,9.24h-25.78v-29.46c0-.96.78-1.74,1.74-1.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflows);
export default __webpack_public_path__ + "static/media/workflows.cc2f92c677c980fb08dcb28ddeeada91.svg";
export { ForwardRef as ReactComponent };